import moment from 'moment';
import Highcharts from 'highcharts';
import { getTooltipText } from './utils';

const DAILY_TICK_INTERVAL = 86400000;
const WEEKLY_TICK_INTERVAL = DAILY_TICK_INTERVAL * 7;
const MONTHLY_TICK_INTERVAL = WEEKLY_TICK_INTERVAL * 4;
const DATEFORMAT = '%b %e';

// const DELTADAYS = -1; // Disable automatic pre & post x-axis labels.
const DELTADAYS = 7;

const getYAxisMin = (minmax) => {
  const min = (minmax.min === 0 && minmax.max === 0) ? 0 : null;
  return min;
}
const getYAxisMax = (minmax) => {
  const max = (minmax.min === 0 && minmax.max === 0) ? 4 : null;
  return max;
}

const getYAxisInterval = (minmax) => {
  return minmax.max - minmax.min < 5 ? 1 : 5;
}

// Prepend a 1st of month label if start date within DELTADAYS of beginning of month
const getXAxisMinDate = (startDate) => {
    const startOfMonth = moment(startDate).utc().startOf('month').valueOf();
    const diffDays = moment(startDate).diff(startOfMonth, 'days');

    // console.log('getMinDate diffDays', diffDays);
    return diffDays <= DELTADAYS ? startOfMonth : null;
}

// Postpend a 1st of month label if end date within DELTADAYS of next beginning of month
const getXAxisMaxDate = (endDate) => {
  const endOfMonth = moment(endDate).utc().endOf('month').valueOf();
  const startOfNextMonth = moment(endDate).utc().add(1, 'month').startOf('month').valueOf();
  const diffDays = moment(endOfMonth).diff(endDate, 'days');

  // console.log('getMaxDate diffDays', diffDays);
  return diffDays <= DELTADAYS ? startOfNextMonth : null;
}

const getXAxisTickInterval = (range) => {
  const diffMonths = moment(range.end).diff(range.start, 'months', true);
  // const diffDays = moment(range.end).diff(range.start, 'days');
  // console.log('diffMonths=', diffMonths, ', diffDays=', diffDays);
  if (diffMonths < 1) return DAILY_TICK_INTERVAL;
  else if (diffMonths < 10) return WEEKLY_TICK_INTERVAL;
  else return MONTHLY_TICK_INTERVAL;
}

export const createERLineChartOptions = (
  startDate: number,
  endDate: number,
  displayRange: {
    start: number,
    end: number
  },
  minmax,
  translation: Function
): Partial<Highcharts.Options> => ({
  chart: { 
    backgroundColor: '#ffffff',
    plotBackgroundColor: 'rgba(204, 204, 204, 0.2)',
  },
  tooltip: {
    style: { 
      fontFamily: 'lato',
      fontSize: '14px',
      color: '#ffffff'
    },
    backgroundColor: '#666875',
    formatter (): string {
      const week = moment(this.x).diff(this.point.series.data[0].x, 'weeks');
      return getTooltipText(this, week, translation, false);
    },
  },
  xAxis: {
    lineColor: 'rgba(0, 0, 0, 0.2)',
    lineWidth: 1,

    // Monthly ticks
    type: 'datetime',
    // tickInterval: getXAxisTickInterval(startDate, endDate),
    tickInterval: getXAxisTickInterval(displayRange),
    startOfWeek: 0, // Start from Sundays.

    // min: getXAxisMinDate(startDate),
    // max: getXAxisMaxDate(endDate),
    min: displayRange.start,
    max: displayRange.end,

    labels: {
      style: {
        fontFamily: 'lato',
        fontSize: '10px',
        color: '#666',
      },
      rotation: -45,
      formatter () {
        const labelTime = moment(this.value).utc().valueOf();
        const displayLabel = Highcharts.dateFormat(DATEFORMAT, labelTime);
        return displayLabel;
      },
    },
    endOnTick: true
  },
  yAxis: {
    lineColor: 'rgba(0, 0, 0, 0.2)',
    lineWidth: 1,

    // Explicitly set min & max if data is all zeros (else line of 0s is vertically centered)
    min: getYAxisMin(minmax),
    max: getYAxisMax(minmax),

    tickInterval: getYAxisInterval(minmax),

    title: { text: 'Teams'},
    labels: {
      style: {
        fontFamily: 'lato',
        fontSize: '10px',
        color: '#666',
      },
      formatter () {
        const value =
          typeof this.value === 'number' ? this.value : parseInt(this.value, 10);
        const displayValue = Math.trunc(value).toLocaleString(); 
        return displayValue;
      },
    }
  },
  legend: {
    enabled: true,
    align: 'left',
    x: 44
  }
});
